var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgLogo = function SvgLogo(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 381 74.92",
    ref: ref,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{font-size:68px;font-family:MyriadPro-Regular, Myriad Pro; fill:#A86D3D;}.cls-2{letter-spacing:-0.02em;}.cls-3{letter-spacing:0em;}.cls-4{letter-spacing:-0.01em;}.cls-5{fill:#2bc6de;}.cls-6{fill:#A86D3D;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(2.61 57.92)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-2"
  }, "P"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-3",
    x: 35.09,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 56.98,
    y: 0
  }, "aiz")), /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(320.85 56.92)"
  }, "er"), /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(205.49 56.92)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-4"
  }, "C"), /*#__PURE__*/React.createElement("tspan", {
    x: 38.69,
    y: 0
  }, "o")), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M171.68,53.33a1.71,1.71,0,0,0,1.78-1.58l7-43.75a1.54,1.54,0,1,0-3-.47l-7,43.74A1.7,1.7,0,0,0,171.68,53.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M203.71,39.37l0,0L182.88,67.85a1.5,1.5,0,0,1-2.42-1.77l18-24.61a7,7,0,0,0,.44-7.61L184.09,7.79a1.5,1.5,0,0,1,2.61-1.48l17.59,31A1.5,1.5,0,0,1,203.71,39.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M284.68,53.33a1.71,1.71,0,0,0,1.78-1.58L293.51,8a1.54,1.54,0,1,0-3-.47l-7.05,43.74A1.7,1.7,0,0,0,284.68,53.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M316.71,39.37l0,0L295.88,67.85a1.5,1.5,0,0,1-2.42-1.77l16.38-22.42a11.25,11.25,0,0,0,.7-12.16L297.09,7.79a1.5,1.5,0,0,1,2.61-1.48l17.59,31A1.5,1.5,0,0,1,316.71,39.37Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 142,
    y: 54.64,
    width: 22,
    height: 8,
    rx: 4
  })))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Logo.0f43af3ce712f5ad8dcdb76471abde14.svg";